export default __webpack_public_path__ + "static/Agile-BoldItalic-0a8b353af5d082a2051a299fb857f17d.ttf";